import React from 'react';
import ProductItemView from '../ProductItemView';
import adaptability from '../../resource/lis/adaptability.svg';


const Adaptability = () => {
    return (
        <ProductItemView
            title="Adaptabilidad"
            items={["Conexión con sistemas de facturación o cotización on-line", "Integramos todos los analizadores o sistemas a través de nuestro middleware", "Soporte de solicitudes medicas electrónicas"]}
            image={adaptability} />
    );
};

export default Adaptability;